var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDkFLag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.435,
    height: 25.379,
    viewBox: "0 0 37.435 25.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_31891",
    x: 0,
    y: 0,
    width: 37.435,
    height: 25.379,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DK-FLag",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Rectangle_31891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31891-2",
    "data-name": "Rectangle 31891",
    width: 34.435,
    height: 22.379,
    transform: "translate(1.5 0.5)",
    fill: "#bc0226"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_40602",
    "data-name": "Path 40602",
    d: "M11.169,0V9.591H0v3.2H11.169V22.38h3.722V12.789H34.434v-3.2H14.891V0Z",
    transform: "translate(0)",
    fill: "#fffaff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDkFLag);
export default __webpack_public_path__ + "static/media/DK-FLag.812b346a4d27713f64ff3d4ff6b0652a.svg";
export { ForwardRef as ReactComponent };